import styled, { css, extensionsHook } from '../styled-components';
const headerFontSize = {
  1: '2em',
  2: '1.375em',
  3: '1em'
};
export const headerCommonMixin = level => css(["color:", ";font-family:", ";font-weight:", ";font-size:", ";line-height:", ";margin:0;display:inline-block;position:relative;"], ({
  theme
}) => theme.colors.primary.main, ({
  theme
}) => theme.typography.headings.fontFamily, ({
  theme
}) => theme.typography.headings.fontWeight, headerFontSize[level], ({
  theme
}) => theme.typography.headings.lineHeight);
export const H1 = styled.h1.withConfig({
  displayName: "headers__H1",
  componentId: "sc-17n7f26-0"
})(["", ";padding:0.375em 0;", ";"], headerCommonMixin(1), extensionsHook('H1'));
export const H2 = styled.h2.withConfig({
  displayName: "headers__H2",
  componentId: "sc-17n7f26-1"
})(["", ";padding:0.375em 0;font-weight:400;", ";"], headerCommonMixin(2), extensionsHook('H2'));
export const H3 = styled.h2.withConfig({
  displayName: "headers__H3",
  componentId: "sc-17n7f26-2"
})(["", ";font-style:italic;padding:0.375em 0;", ";"], headerCommonMixin(3), extensionsHook('H3'));
export const RightPanelHeader = styled.h3.withConfig({
  displayName: "headers__RightPanelHeader",
  componentId: "sc-17n7f26-3"
})(["color:", ";", ";"], ({
  theme
}) => theme.rightPanel.textColor, extensionsHook('RightPanelHeader'));
export const UnderlinedHeader = styled.h5.withConfig({
  displayName: "headers__UnderlinedHeader",
  componentId: "sc-17n7f26-4"
})(["border-bottom:1px solid #e9e8e8;margin:1em 0;color:#a7a5a5;font-weight:normal;text-transform:uppercase;font-size:0.875em;line-height:20px;letter-spacing:0.7px;", ";"], extensionsHook('UnderlinedHeader'));